/** @jsxImportSource @emotion/react */
import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { CopyDeleteOverlay, CopyDeleteContent, CopyDeleteItem } from './copy-delete.styled';

type Props = {
  open: boolean;
  onClose: () => void;
  onCopy: () => void;
  onDelete: () => void;
  anchorRect: DOMRect | null;
  copyLabel?: string;
};

export const NotesCopyDeleteModal: React.FC<Props> = ({
  open,
  onClose,
  onCopy,
  onDelete,
  anchorRect,
  copyLabel = "Copy",
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <CopyDeleteOverlay />
        <CopyDeleteContent anchorRect={anchorRect} aria-describedby={undefined}>
          <Dialog.Title style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' }}>
            Note options
          </Dialog.Title>
          <CopyDeleteItem type="button" onClick={onCopy}>
            {copyLabel}
          </CopyDeleteItem>
          <CopyDeleteItem type="button" className="delete" onClick={onDelete}>
            Delete
          </CopyDeleteItem>
        </CopyDeleteContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
